module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLightItalic.bd5b02db.ttf";